module.exports = __webpack_public_path__ + "@/assets/img/sumadi.9599c00f.png";